import { SearchSuggestionViewModel } from "../api/generated/models/SearchSuggestionViewModel";

/**
 * Mirrors SearchSuggestion.Normalize on the backend: the stored keywords are
 * normalized, so a zero-result query must be normalized the same way before it
 * can be looked up.
 */
export const normalizeKeyword = (keyword: string): string =>
  keyword.trim().replace(/\s+/g, " ").toLowerCase();

export const indexSuggestionsByKeyword = (
  suggestions: SearchSuggestionViewModel[]
): Map<string, SearchSuggestionViewModel> => {
  const byKeyword = new Map<string, SearchSuggestionViewModel>();
  suggestions.forEach((suggestion) => {
    (suggestion.keywords ?? []).forEach((keyword) => {
      byKeyword.set(normalizeKeyword(keyword), suggestion);
    });
  });
  return byKeyword;
};

/**
 * "2 merchants + 1 category" — what a suggestion maps a query to, for the
 * zero-result table and the list, where the full chips would not fit.
 */
export const describeMapping = (suggestion: SearchSuggestionViewModel): string => {
  const merchants = suggestion.businessIds?.length ?? 0;
  const categories = suggestion.categoryIds?.length ?? 0;
  const parts: string[] = [];
  if (merchants > 0) parts.push(`${merchants} ${merchants === 1 ? "merchant" : "merchants"}`);
  if (categories > 0) parts.push(`${categories} ${categories === 1 ? "category" : "categories"}`);
  return parts.length > 0 ? parts.join(" + ") : "nothing";
};

export const normalizeLogoUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  return url.startsWith("//") ? `https:${url}` : url;
};
